/*if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}*/

if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      // Standard function to get values for the theme
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });
      return Array.from(selectedValues.values());
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    // ======================================================
    // V4 FIX: SMART MATCHING (IGNORES CUSTOM FIELDS)
    // ======================================================
    updateMainPrice() {
      const productInfo = this.closest('product-info');
      if (!productInfo) return;

      // 1. Get Product Data
      const jsonScript = productInfo.querySelector('#ProductData');
      if (!jsonScript) return;
      const productData = JSON.parse(jsonScript.textContent);

      // 2. Get User Selections
      // We grab ALL checked inputs or selects inside this block
      const allInputs = Array.from(this.querySelectorAll('input:checked, select'));
      const userValues = allInputs.map(input => input.value);

      // 3. Find Matching Variant (Fuzzy Logic)
      // We look for a variant where the Main Option (e.g. "18k Yellow Gold")
      // exists in the user's selection. We ignore the other fields.
      const matchedVariant = productData.variants.find(variant => {
        // Check if the variant's option (e.g. "18k Yellow Gold") is currently selected
        // We check index 0 because "Material" is usually the first option.
        const mainOption = variant.options[0]; 
        return userValues.includes(mainOption);
      });

      // 4. Update the Price
      if (matchedVariant) {
          const sectionId = productInfo.dataset.section;
          let priceContainer = document.getElementById(`Price-${sectionId}`);
          
          // Fallback selector if ID is missing
          if (!priceContainer) {
             priceContainer = productInfo.querySelector('.price, .f-price');
          }

          if (priceContainer) {
             // Convert cents to dollars (200000 -> 2000.00)
             const priceInDollars = matchedVariant.price / 100;
             const formattedPrice = priceInDollars.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
             });

             // Update text
             const moneyItem = priceContainer.querySelector('.price-item, span');
             const newPriceText = `$${formattedPrice}`;
             
             if (moneyItem) {
                 moneyItem.innerText = newPriceText;
             } else {
                 priceContainer.innerText = newPriceText;
             }
          }
      }
    }
    // ======================================================

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        
        // Trigger the Smart Price Update
        this.updateMainPrice();

        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}